import { Box, Typography } from '@pocketlaw/tetris';
export function AccessManagementListState(props) {
    const { icon, title, subtitle, actions } = props;
    return (<Box flexDirection="column" gap="sm" alignItems="center" justifyContent="center" pt="2xl">
      {icon}
      <Box flexDirection="column" alignItems="center">
        {title && (<Typography $fontWeight="semibold" $fontSize="large">
            {title}
          </Typography>)}
        {subtitle && (<Typography $lineHeight="neutralized" $fontSize="small">
            {subtitle}
          </Typography>)}
      </Box>
      {actions && <Box mt="md">{actions}</Box>}
    </Box>);
}
